import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';

import { AppComponent } from '@app/app.component';
import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService, PageMetaService, SharedService, User } from '@app/core';
import { InvoiceService } from '@app/modules/invoice/services';
import { JoyrideService } from 'ngx-joyride';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { isArray, NgSelectComponent } from '../propeller';
import { NavbarService } from './navbar.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() isSidebarOpen: boolean = false;
  @Output() isSidebarOpenChange: EventEmitter<boolean>;
  loggedinUser: User;
  title$: Observable<string> = this.pageMetaService.title.asObservable();
  backLink$: Observable<string | any[]> = this.pageMetaService.backLink.asObservable();
  @ViewChild('singleSelectionDropdown') singleSelectionDropdown: NgSelectComponent;
  @ViewChild('singleSelectionCompanyDropdown') singleSelectionCompanyDropdown: NgSelectComponent;
  syncCode: string;
  isSetAllEntities = false;
  selectedEntities = new FormControl([]);
  selectedCompany = new FormControl();
  tempSelectedEntities: { id: string, name: string }[] = [];
  entities = [];
  singleSelectEntities = [];
  singleSelectCompanies = [];
  hideBreadCrumb = true;
  headerFilterForm: FormGroup;
  parentCompanyList: any = [];
  selectedEntitiesList: any = [];
  entitiList: any = [];
  allEntities: any = [];
  selectedCompanySubscription: Subscription;
  showBckButton = true;
  selectedCompanyListSubscription: Subscription;
  invoiceActiveGroup = '';
  dashboardText = false;
  appComponent: AppComponent;
  token: string;
  PEFormGroup: FormGroup;
  invoiceFieldType = new FormControl(null);
  loggedInUserName: string;
  companyName: string;
  isTooltipStatic = false;
  singleSelectModules = this.appGlobals.singleSelectModules;
  multiSelectModules = this.appGlobals.multiSelectModules;
  singleSelectCompanyModules = this.appGlobals.singleSelectCompanyModules;
  @ViewChild(NgSelectComponent) ngSelectCompanyDropdown!: NgSelectComponent;
  previousURL: string = '';
  currentURL: string = '';
  isPageRefreshed = false;
  isCompanyDropdownOpen = false;
  private companySearch$ = new Subject<string>();
  companyMetadata: any = {
    totalAllocatedCompanies: 0,
    totalPendingInvoices: 0
  }


  constructor(
    private sharedService: SharedService,
    private pageMetaService: PageMetaService,
    public authService: AuthService,
    private navbarService: NavbarService,
    private invoiceService: InvoiceService,
    public router: Router,
    public appGlobals: AppGlobals,
    private entityService: EntityService,
    private readonly joyrideService: JoyrideService,
    private cdRef: ChangeDetectorRef, private readonly formBuilder: FormBuilder) {
    this.isSidebarOpenChange = new EventEmitter<boolean>(this.isSidebarOpen);
    this.loggedinUser = this.authService.user;
    this.invoiceService.activeInvoiceGroup$.pipe(debounceTime(500)).subscribe(async group => {
      if ((group && this.authService.user.isAdmin) && this.router.url === '/invoice') {
        this.invoiceActiveGroup = group;
        await this.getCompanyList();
      }
    });

    if (this.authService.user.isOutlet || this.authService.user.isOwner) {
      this.sharedService.currentSyncCode.subscribe(syncCode => {
        if (!syncCode) {
          this.getSyncCode();
        } else {
          this.syncCode = syncCode;
        }
      })
    }

    this.router.events.subscribe((res: any) => {
      if (res?.url?.includes('/dashboard')) {
        this.dashboardText = true;
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!this.authService?.user?.isOutlet) {
          if (this.currentURL) {
            this.previousURL = this.currentURL;
          }
          this.currentURL = event.url;
          this.onRouteChange();
        }
      });

    this.companySearch$.pipe(debounceTime(this.appGlobals.defaultDebounceTime), distinctUntilChanged())
      .subscribe(term => {
        if (term.length >= 3) {
          const queryParams = { name: term };
          localStorage.setItem('searchCompany', term);

          this.entityService.setCompanies(queryParams).subscribe({
            next: (response: any) => {
              this.entityService.dataSubject.next(response);
            }
          });
        }
      });
  }

  ngOnInit() {
    this.PEFormGroup = this.formBuilder.group({
      invoiceFieldType: [this.appGlobals.PURCHASE]
    });
    if (this.authService.user.isOwner) {
      this.initEntitiesOnce();
      this.onRouteChange();
      this.listenToCompanyOrEntityStatusChange();
    } else if (this.authService.user.isAdmin && this.router.url !== '/invoice') {
      this.getCompanyList();
    }


    if (this.authService.user.isOwner || this.authService.user.isOutlet) {

      const supplierWiseRateExclusive = this.sharedService.getSupplierTags();
      if (!supplierWiseRateExclusive) {
        this.sharedService.fetchSupplierTags();
      }

      const suggestedGSTAndPan = this.sharedService.getSuggestedGSTAndPan();
      if (!suggestedGSTAndPan) {
        this.sharedService.fetchSuggestedGSTAndPan();
      }
    }

    this.token = this.authService.token;

    this.sharedService.currentNavBarPETab.subscribe((tab) => {
      if (tab) {
        this.peF.invoiceFieldType.setValue(tab);
        this.markPEExplicitly(tab);
      } else {
        const tabFromLocalStorage = localStorage.getItem('navBarPETab');
        this.peF.invoiceFieldType.setValue(tabFromLocalStorage || this.appGlobals.PURCHASE);
        this.sharedService.updateNavBarPETab(tabFromLocalStorage || this.appGlobals.PURCHASE);
        this.markPEExplicitly(tabFromLocalStorage || this.appGlobals.PURCHASE);
      }
    });

    this.sharedService.resetSelectedEntityFormControl$.subscribe(() => {
      this.selectedEntities.reset();
      this.entities = [];
      this.entityService.selectedEntities.next([]);
      localStorage.removeItem('selectedEntities');
    });

    if (!this.authService.user?.isAdmin) {
      document.addEventListener('visibilitychange', () => {
        const isAnyDropdownOpen = (this.canShowMultiSelectCompanyDropdown() || this.canShowSingleCompanyDropdown() || this.canShowSingleEntityDropdown());
        if (isAnyDropdownOpen && this.ngSelectCompanyDropdown?.isOpen) {
          this.sharedService.toggleBlurBackground(true);
        } else {
          this.removeBlurBackground();
        }
      });
    }

    // Sync single-entity dropdown when another component reverts the selection
    this.entityService.singleSelectedEntity$.subscribe((entity) => {
      if (entity && this.singleSelectEntities?.length > 0) {
        const currentValue = this.selectedEntities.value as any;
        if (currentValue && currentValue.id !== entity.id) {
          this.setSingleSelectedEntity(entity);
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (localStorage.getItem('profileSetupCurrentPage') == 'completed') { // If Profile setup is completed then only start the tour
      this.startTourGuide();
    }

    this.sharedService.openSingleEntitySelect$.subscribe(() => {
      this.openSingleSelectDropdown();
    });

    this.sharedService.openSingleSelectionCompanyDropdown$.subscribe(() => {
      this.openSingleSelectCompanyDropdown();
    })
  }

  openSingleSelectDropdown() {
    this.singleSelectionDropdown?.open();
  }

  openSingleSelectCompanyDropdown() {
    this.singleSelectionCompanyDropdown?.open();
  }

  startTourGuide() {
    const isFinished = JSON.parse(localStorage.getItem('isTourGuideFinished')); // if tour guide is finished then do not start
    if (!isFinished) {

      if (!JSON.parse(localStorage.getItem('isSidebarOpen'))) {
        this.openSideBar();
      }
      setTimeout(() => {
        this.joyrideService.startTour(
          {
            steps: ['firstStep', 'secondStep', 'thirdStep', 'fourthStep'],
            stepDefaultPosition: 'top',
            showCounter: false,
            customTexts: {
              prev: 'Back', next: 'Next', done: 'Upload Now'
            },

          }
        ).subscribe(
          (step) => {
            if (step?.number == 2) {
              if (step.actionType == 'NEXT') {
                if (!document.getElementsByClassName('explore-product-panel')[0].classList.contains('show')) {
                  document.getElementById('exploreProductsToggleBtn')?.click();
                }
              }
            } else if (step?.number == 3) {
              window.scrollTo({
                top: 0,
                left: document.body.scrollHeight,
                behavior: "smooth"
              });

            } else if (step?.number == 4) {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
              });
            }
          },
          (error) => {
            console.log('error:', error);
          },
          () => {
            //Tour is finished here
            localStorage.setItem('isTourGuideFinished', JSON.stringify(true));
            if (document.getElementsByClassName('explore-product-panel')[0].classList.contains('show')) {
              document.getElementById('exploreProductsToggleBtn')?.click();
            }
          }
        );
      }, 600);
    }
  }

  get peF() {
    return this.PEFormGroup.controls;
  }

  markPEExplicitly(tab) {
    setTimeout(() => {
      const ele = document.getElementById("pe-checkbox") as HTMLInputElement;
      if (ele) {
        ele.checked = tab == this.appGlobals.EXPENSE.toLowerCase();
      }
    }, 100);
  }

  createFilterForm() {
    this.selectedCompanySubscription = this.selectedCompany.valueChanges.pipe(debounceTime(1000)).subscribe(searchTerm => {
      if (!searchTerm) {
        this.entities = [];
        this.selectedEntities.setValue([]);
        this.entityService.setSelectedEntities([]);
        this.entityService.setLastSelectedCompany(null);
        this.entityService.setEntities([]);
        this.entityService.setEntitiesChanges({ isEntityChanged: true });
        return;
      }

      this.selectedEntitiesList = this.allEntities.find(company => company.id === searchTerm)?.outlets;
      this.entities = [
        ...[{
          id: '0',
          name: 'All'
        }],
        {
          id: searchTerm,
          group: 'Parent Entity',
          name: this.parentCompanyList.find(p => p.id === searchTerm)?.name,
        },
        ...this.selectedEntitiesList?.map(entity => ({
          group: 'Child Entity',
          ...entity,
          name: entity.name
        })) || []
      ];

      const lastSelectedCompany = this.entityService.getLastSelectedCompany();
      const ids = this.entities.map((entity: any) => { return entity.id }).filter(id => id != 0).join();

      let isAPICalled = true;

      if (lastSelectedCompany != searchTerm) {
        isAPICalled = false;

        this.selectedEntities.setValue(this.entities);
        this.entityService.setSelectedEntities(this.entities);
        this.entityService.setLastSelectedCompany(searchTerm);
        this.entityService.setEntities(this.entities);
        this.entityService.setEntitiesChanges({ isEntityChanged: true });

        this.sharedService.fetchSupplierTags({ company: ids });
        this.sharedService.fetchSuggestedGSTAndPan({ company: ids });
      } else {

        let selectedEntities = this.entityService.getSelectedEntities();
        if (selectedEntities.length) {

          selectedEntities.forEach((selectedEntity: any) => {
            // Display full entity name
          });
          selectedEntities = selectedEntities.filter((selectedEntity) => this.entities.find(entity => entity.id === selectedEntity.id && entity.id != 0));
          if (selectedEntities?.length == this.entities.length - 1) {
            selectedEntities.unshift({ id: '0', name: 'All' });
          }
          this.selectedEntities.setValue(selectedEntities);
          this.entityService.setSelectedEntities(selectedEntities);
          this.entityService.setEntities(selectedEntities);
          if (!this.isCompanyDropdownOpen) {
            this.entityService.setEntitiesChanges({ isEntityChanged: true });
          }
        }
      }

      const supplierWiseRateExclusive = this.sharedService.getSupplierTags();
      if (!supplierWiseRateExclusive && this.entities.length && isAPICalled) {
        this.sharedService.fetchSupplierTags({ company: ids });
      }

      const suggestedGSTAndPan = this.sharedService.getSuggestedGSTAndPan();
      if (!suggestedGSTAndPan && this.entities.length && isAPICalled) {
        this.sharedService.fetchSuggestedGSTAndPan({ company: ids });
      }

    });
  }

  onCompanySearch($event) {
    this.companySearch$.next($event.term);
    // if ($event.term?.length >= 3 && !$event.items?.length) {
    //   const queryParams = { name: $event.term }
    //   localStorage.setItem('searchCompany', $event.term);

    //   this.entityService.setCompanies(queryParams).subscribe({
    //     next: (response: any) => {
    //       this.entityService.dataSubject.next(response);
    //     }
    //   })
    // }
  }

  async getCompanyList() {
    this.selectedCompanyListSubscription = this.entityService.companies$.subscribe((response: any) => {
      if (!response) {
        return;
      }

      if (this.invoiceActiveGroup === 'assigned' && this.router.url === '/invoice') {
        // this.parentCompanyList = response.filter(company => (company.parent === null || !company.parent) && company.assigned);
        if (response?.allocationCompany?.length) {
          this.parentCompanyList = response.allocationCompany
        } else {
          this.parentCompanyList = response.company
        }

        // Sort companies by totalPendingInvoices in descending order for MyQueue
        this.parentCompanyList = this.parentCompanyList.sort((a, b) => {
          const countA = a.totalPendingInvoices || 0;
          const countB = b.totalPendingInvoices || 0;
          return countB - countA;
        });

        // Update company metadata for admin users in MyQueue
        this.companyMetadata.totalAllocatedCompanies = response.allocationCompany?.length || 0;

        // Calculate total pending invoices from all companies
        let totalPendingInvoices = 0;
        if (response.allocationCompany?.length) {
          totalPendingInvoices = response.allocationCompany.reduce((total: number, company: any) => {
            return total + (company.totalPendingInvoices || 0);
          }, 0);
        }

        this.companyMetadata.totalPendingInvoices = totalPendingInvoices;
      } else {
        if (response.company?.length) {
          if (response?.allocationCompany?.length) {
            this.parentCompanyList = [...response.company];
            this.parentCompanyList = [...new Map(this.parentCompanyList.map(user => [user.id, user])).values()];
          } else {
            this.parentCompanyList = response.company;
          }
        }
      }

      this.allEntities = this.parentCompanyList;
      const lastSelectedCompany = this.entityService.getLastSelectedCompany();
      this.createFilterForm();

      const companyNameExist = this.parentCompanyList.find(company => company.id === lastSelectedCompany);

      if (lastSelectedCompany && companyNameExist) {
        this.selectedCompany.setValue(lastSelectedCompany);
      } else {
        this.selectedCompany.setValue(this.parentCompanyList.length ? this.parentCompanyList[0].id : '');
      }
    });
  }

  initEntitiesOnce() {
    if (this.authService.isLoggedIn) {
      if (!this.authService.user.isAdmin) {
        this.entities = this.entityService.getEntities();
        this.singleSelectEntities = JSON.parse(JSON.stringify(this.entityService.getEntities()));
        this.singleSelectCompanies = JSON.parse(JSON.stringify(this.entityService.getSingleDropdownCompanies()));
        this.markSingleSelectedEntitiesAsUnchecked();
        this.markSingleSelectedCompaniesAsUnchecked();

        if (!this.entities.length) {
          this.entityService.fetchEntities().subscribe((companies) => {
            if (companies?.length && !this.entities?.length) {
              companies.forEach((company) => {
                company.outlets?.forEach((outlet) => {
                  this.entities.push({
                    id: outlet.id,
                    group: company.name, // this will group all outlets under company
                    name: outlet.name,
                    parent: company.id,
                    isSelected: false,
                    parentId: company.id,
                    subscriptionDate: company.subscriptionDate,
                    isPaidCompany: company.isPaidCompany
                  });
                });

                // push companies in to singleSelectCompanies
                this.singleSelectCompanies.push({
                  id: company.id,
                  group: company.name,
                  name: company.name,
                  isSelected: false,
                  subscriptionDate: company.subscriptionDate,
                  isPaidCompany: company.isPaidCompany
                });
              });

              this.entityService.setEntities(this.entities);

              // single select companies
              if (this.singleSelectCompanies.length) {
                this.entityService.setSingleDropdownCompanies(this.singleSelectCompanies);
              }

              // single select entities
              this.singleSelectEntities = JSON.parse(JSON.stringify(this.entities));

              this.setSelectedEntitiesOnReRender();
              this.disableGroupWiseEntities();
            }
          })
        } else { // entities available either from subject or from local storage
          this.tempSelectedEntities = this.entityService.getSelectedEntities();
          if (this.tempSelectedEntities?.length) {
            this.selectedEntities.setValue(this.tempSelectedEntities);
            this.markEntitiesFromFormControl();
            this.disableGroupWiseEntities();
          } else {
            this.setSelectedEntitiesOnReRender();
            this.disableGroupWiseEntities();
          }
        }
        this.entityService.setCurrentCompanySelection(this.selectedEntities.value);
      }
    }
  }

  onRouteChange() {
    if (this.canShowMultiSelectCompanyDropdown()) {
      // check if single select company dropdown was open before
      if (this.wasSingleSelectCompanyDropdown()) {
        // get last selected company
        this.restoreMultiSelectFromSingleCompany(this.entityService.getSingleSelectedCompany());
      } else if (this.wasSingleEntityDropdown()) {
        // check if dropdown was from single select entity
        this.restoreMultiSelectFromSingleEntity(this.entityService.getSingleSelectedEntity());
      } else if ((this.checkIfPrimaryCompanyChanged() || this.wasEntityManagementPage()) && !this.checkIfEntityAddedOrUpdated()) {
        // if primary company changed
        this.selectedEntities.reset();
        this.setSelectedEntitiesOnReRender();
        this.disableGroupWiseEntities();
      } else if (this.checkIfEntityAddedOrUpdated()) {
        // fetch entities from local storage
        this.entities = JSON.parse(localStorage.getItem('entities'));
        localStorage.removeItem('wasEntityAddedOrUpdated');
        this.selectedEntities.reset();
        this.setSelectedEntitiesOnReRender();
        this.disableGroupWiseEntities();
      } else if (this.selectedEntities.value && !isArray(this.selectedEntities.value)) {
        this.selectedEntities.setValue([this.selectedEntities.value]);
      }
    } else if (this.canShowSingleCompanyDropdown()) { // for single select COMPANY
      // if multi select company dropdown was open before
      if (this.wasMultiSelectCompanyDropdown()) {
        // get last selected entities 
        this.restoreSingleCompanyFromMultiSelect(this.entityService.getSelectedEntities());

      } else if (this.wasSingleEntityDropdown()) {
        this.restoreSingleCompanyFromSingleEntity(this.entityService.getSingleSelectedEntity());
      } else if (this.checkIfPrimaryCompanyChanged() || this.wasEntityManagementPage()) {
        // check if primary company changed
        this.setPrimaryCompanyAsSelected();
      } else if (this.wasCompanyManagementPage()) {
        this.setPrimaryCompanyAsSelected();
      } else {
        // page is refreshed, get last selected company from local storage
        this.restoreSingleCompanyFromLocalStorage(this.entityService.getSingleSelectedCompany());
      }
    } else if (this.canShowSingleEntityDropdown()) { // such as invoice upload (for single select entity)
      this.singleSelectEntities = JSON.parse(JSON.stringify(this.entityService.getEntities()));
      if (this.wasMultiSelectCompanyDropdown()) {
        // get last selected entities from local storage
        this.restoreSingleEntityFromMultiSelect(this.entityService.getSelectedEntities());
      } else if (this.wasSingleSelectCompanyDropdown()) {
        // get last single selected company
        this.restoreSingleEntityFromSingleCompany(this.entityService.getSingleSelectedCompany());
      } else if (this.checkIfPrimaryCompanyChanged() || this.wasEntityManagementPage()) {
        // if primary company is changed then set first entity of primary company as selected
        // or else if any of entity is activated/deactivated then set first entity of primary company as selected
        this.setFirstEntityOfPrimaryCompanyAsSelected();
      } else {
        // on page refresh, get last selected entity from local storage
        this.restoreSingleEntityFromLocalStorage(this.entityService.getSingleSelectedEntity());
      }
    }
  }

  listenToCompanyOrEntityStatusChange() {
    this.entityService.entitiesSubject$.subscribe((entities) => {
      if (entities?.length) {
        this.entities = [...entities];

        if (Array.isArray(this.selectedEntities.value) && this.selectedEntities.value?.length) {
          const updatedSelectedEntities = this.selectedEntities.value.map((selectedEntity: any) => {
            const matchedEntity = this.entities.find(entity => entity.id === selectedEntity.id);

            if (matchedEntity) {
              // mark entity as selected
              matchedEntity.isSelected = true;

              // return updated selectedEntity with entity.name
              return { ...selectedEntity, name: matchedEntity.name };
            }

            return selectedEntity;
          });

          // update form control value
          this.selectedEntities.setValue(updatedSelectedEntities, { emitEvent: false });

          this.disableGroupWiseEntities();
        }
      }
    });

  }

  /**
   * This method will set all entities as selected based on parent id
   * @param singleSelectedCompany 
   */
  restoreMultiSelectFromSingleCompany(singleSelectedCompany) {
    if (singleSelectedCompany) {
      const selectedEntities = [];
      // set all entities of singleSelectedCompany as selected
      this.entities.forEach((entity) => {
        if (entity.parentId == singleSelectedCompany.id) {
          entity.isSelected = true;
          entity.disabled = false;
          selectedEntities.push(entity);
        } else {
          entity.isSelected = false;
          entity.disabled = true;
        }
      });
      this.selectedEntities.setValue(selectedEntities);
      this.entityService.setSelectedEntities(selectedEntities);
    }
  }

  /**
   * This method will set multi select from single select entity
   * It will set all entities of same parent as selected and others as unselected
   * @param selectedEntity 
   */
  restoreMultiSelectFromSingleEntity(selectedEntity) {
    if (selectedEntity) {
      // set selected entity as selected in multi select dropdown
      const findEntityIndex = this.entities.findIndex((entity) => entity.id == selectedEntity.id);
      if (findEntityIndex > -1) {
        this.entities[findEntityIndex].isSelected = true;
        this.entities[findEntityIndex].disabled = false;

        this.entities.forEach((entity, index) => {
          if (findEntityIndex != index) {
            entity.isSelected = false;
          }
          if (entity.parentId == selectedEntity.parentId) {
            entity.disabled = false;
          } else {
            entity.disabled = true;
          }
        });

        this.selectedEntities.setValue([this.entities[findEntityIndex]]);
        this.entityService.setSelectedEntities([this.entities[findEntityIndex]]);
      }
    }
  }

  /**
   * This method will get first entity and get parent id, and will set parent company as selected
   * @param lastSelectedEntities 
   */
  restoreSingleCompanyFromMultiSelect(lastSelectedEntities) {
    if (lastSelectedEntities?.length) {
      // find parent of last selected entity
      const parentId = lastSelectedEntities[0].parentId;
      const findParentIndex = this.singleSelectCompanies.findIndex((singleCompany) => singleCompany.id == parentId);
      if (findParentIndex > -1) {
        // set parent as selected in dropdown
        this.singleSelectCompanies[findParentIndex].isSelected = true;
        this.singleSelectCompanies.forEach((singleCompany, index) => {
          if (index != findParentIndex) {
            singleCompany.isSelected = false;
          }
        });
        this.selectedEntities.setValue(this.singleSelectCompanies[findParentIndex]);
        this.entityService.setSingleSelectedCompany(this.singleSelectCompanies[findParentIndex]);
      }
    }
  }

  /**
   * This method will set single company from single Entity
   * @param selectedEntity 
   */
  restoreSingleCompanyFromSingleEntity(selectedEntity) {
    if (selectedEntity) {
      // find parent company of selected entity
      const findParentIndex = this.singleSelectCompanies.findIndex((singleCompany) => singleCompany.id == selectedEntity.parentId);
      if (findParentIndex > -1) {
        // set parent company as selected in dropdown
        this.singleSelectCompanies[findParentIndex].isSelected = true;
        this.selectedEntities.setValue(this.singleSelectCompanies[findParentIndex]);
        this.entityService.setSingleSelectedCompany(this.singleSelectCompanies[findParentIndex]);
        // uncheck all other companies
        this.singleSelectCompanies.forEach((singleCompany, index) => {
          if (index != findParentIndex) {
            singleCompany.isSelected = false;
          }
        })
      }
    }
  }

  /**
   * This method will set single company from local storage
   * @param singleSelectedCompany 
   */
  restoreSingleCompanyFromLocalStorage(singleSelectedCompany) {
    if (singleSelectedCompany) {
      this.selectedEntities.setValue(singleSelectedCompany);
      this.singleSelectCompanies.forEach((singleCompany, index) => {
        if (singleCompany.id != singleSelectedCompany.id) {
          singleCompany.isSelected = false;
        }
      });
    }
  }

  /**
   * This method will set single Entity from multi select 
   * @param lastSelectedEntities 
   */
  restoreSingleEntityFromMultiSelect(lastSelectedEntities) {
    if (lastSelectedEntities?.length) {
      const parentId = lastSelectedEntities[0].parentId;
      // find first entity from last selected entities having same parentId
      const findFirstEntityOfParentIndex = this.singleSelectEntities.findIndex((singleEntity) => singleEntity.parentId == parentId);

      if (findFirstEntityOfParentIndex > -1) {
        this.singleSelectEntities[findFirstEntityOfParentIndex].isSelected = true;
        this.singleSelectEntities[findFirstEntityOfParentIndex].disabled = false;
        this.selectedEntities.setValue(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.entityService.setSingleSelectedEntity(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.singleSelectEntities.forEach((singleEntity, index) => {
          if (findFirstEntityOfParentIndex != index) {
            singleEntity.disabled = false;
            singleEntity.isSelected = false;
          }
        });
        this.singleSelectEntities = [...this.singleSelectEntities];
      }
    }
  }

  /**
   * This method will set single entity from single company
   * @param singleSelectedCompany 
   */
  restoreSingleEntityFromSingleCompany(singleSelectedCompany) {
    if (singleSelectedCompany) {
      // get first entity of parent company
      const findFirstEntityOfParentIndex = this.singleSelectEntities.findIndex((singleEntity) => singleEntity.parentId == singleSelectedCompany.id);
      if (findFirstEntityOfParentIndex > -1) {
        this.singleSelectEntities[findFirstEntityOfParentIndex].isSelected = true;
        this.selectedEntities.setValue(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.entityService.setSingleSelectedEntity(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.singleSelectEntities.forEach((singleEntity, index) => {
          singleEntity.disabled = false;
          if (findFirstEntityOfParentIndex != index) {
            singleEntity.isSelected = false;
          }
        });
      }
    }
  }

  /**
   * This method will set single entity from local storage
   * @param singleSelectedEntity 
   */
  restoreSingleEntityFromLocalStorage(singleSelectedEntity) {
    if (singleSelectedEntity) {
      this.selectedEntities.setValue(singleSelectedEntity);
      this.singleSelectEntities.forEach((singleEntity, index) => {
        singleEntity.disabled = false;
        if (singleEntity.id != singleSelectedEntity.id) {
          singleEntity.isSelected = false;
        }
      })
    } else {
      this.restoreSingleEntityFromMultiSelect(this.entityService.getSelectedEntities());
    }
  }

  setFirstEntityOfPrimaryCompanyAsSelected() {

    if (this.singleSelectEntities?.length) {
      const findFirstEntityOfParentIndex = this.singleSelectEntities.findIndex((singleEntity) => singleEntity.parentId == this.authService.user.company.id);

      if (findFirstEntityOfParentIndex > -1) {
        this.singleSelectEntities[findFirstEntityOfParentIndex].isSelected = true;
        this.selectedEntities.setValue(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.entityService.setSingleSelectedEntity(this.singleSelectEntities[findFirstEntityOfParentIndex]);
        this.singleSelectEntities.forEach((singleEntity, index) => {
          singleEntity.disabled = false;
          if (findFirstEntityOfParentIndex != index) {
            singleEntity.isSelected = false;
          }
        });
      }

    }

  }

  /**
   * This method will set primary company as selected
   */
  setPrimaryCompanyAsSelected() {
    if (this.singleSelectCompanies?.length) {
      const primaryCompanyId = this.authService.user?.company?.id;
      const findPrimaryCompanyIndex = this.singleSelectCompanies.findIndex((singleCompany) => singleCompany.id == primaryCompanyId);

      if (findPrimaryCompanyIndex > -1) {
        this.singleSelectCompanies[findPrimaryCompanyIndex].isSelected = true;

        this.singleSelectCompanies.forEach((singleCompany, index) => {
          if (index != findPrimaryCompanyIndex) {
            singleCompany.isSelected = false;
          }
        });

        this.selectedEntities.setValue(this.singleSelectCompanies[findPrimaryCompanyIndex]);
        this.entityService.setSingleSelectedCompany(this.singleSelectCompanies[findPrimaryCompanyIndex]);
      }
    }
    console.log('this.singleSelectCompanies:', this.singleSelectCompanies);

  }

  markEntitiesFromFormControl() {
    if (this.selectedEntities.value?.length) {
      this.entities.forEach((entity) => {
        this.selectedEntities.value.find((selectedEntity) => selectedEntity.id == entity.id) ? entity.isSelected = true : entity.isSelected = false;
      });
      this.entities = [...this.entities];
    }
  }

  /**
   * This method will set selected entites on re-render
   */
  setSelectedEntitiesOnReRender() {
    if (!this.selectedEntities.value?.length) {
      this.tempSelectedEntities = [];
      this.entities.forEach((entity) => {
        if (entity.parentId == this.authService.user?.company.id) {
          this.tempSelectedEntities.push(entity);
          entity.isSelected = true;
        } else {
          entity.isSelected = false;
        }
      });
      this.entities = [...this.entities];
      this.selectedEntities.setValue(this.tempSelectedEntities);
      this.entityService.setSelectedEntities(this.selectedEntities.value);
    }
  }

  /**
   * This method will mark each entity as unchecked for single selection array
   */
  markSingleSelectedEntitiesAsUnchecked() {
    if (this.singleSelectEntities?.length) {
      this.singleSelectEntities.forEach((singleSelectedEntity) => {
        singleSelectedEntity.isSelected = false;
      });
    }
  }

  markSingleSelectedCompaniesAsUnchecked() {
    if (this.singleSelectCompanies?.length) {
      this.singleSelectCompanies.forEach((singleSelectedCompany) => {
        singleSelectedCompany.isSelected = false;
      });
    }
  }

  /**
   * This method will find and update isSelected flag for the selected entity
   * and it will update form control
   * @param singleSelectedEntity 
   */
  setSingleSelectedEntity(singleSelectedEntity) {
    const findSelectedEntityIndex = this.singleSelectEntities.findIndex((selectedEntity) => selectedEntity.id == singleSelectedEntity.id);
    if (findSelectedEntityIndex > -1) {
      this.singleSelectEntities[findSelectedEntityIndex].isSelected = true;
      this.selectedEntities.setValue(this.singleSelectEntities[findSelectedEntityIndex]);

      this.singleSelectEntities.forEach((singleEntity, index) => {
        if (findSelectedEntityIndex != index) {
          singleEntity.disabled = false;
        }
      });
    }
  }

  onSelectClose() {
    this.isTooltipStatic = false;
    this.removeBlurBackground();
  }

  removeBlurBackground() {
    this.sharedService.toggleBlurBackground(false);
  }

  onEntitySelectionClose(selection: any) {
    this.onSelectClose();

    if (selection.isMultiSelect) {
      this.entityService.setSelectedEntities(this.selectedEntities.value);
      if (!this.selectedEntities.value.length && this.entityService.getLastSelectedEntities().length) {
        this.tempSelectedEntities = this.entityService.getLastSelectedEntities();
        this.selectedEntities.setValue(this.tempSelectedEntities);
        this.entityService.setSelectedEntities(this.selectedEntities.value);
        this.markEntitiesFromFormControl();
        this.entityService.setCurrentCompanySelection(this.selectedEntities.value);
      } else if (!this.selectedEntities.value.length) {
        this.initEntitiesOnce();
      }
      // check if entity dropdown value is changed then only call APIs
      if (JSON.stringify(this.selectedEntities.value) !== JSON.stringify(this.entityService.getLastSelectedEntities())) {
        this.entityService.setEntitiesChanges({ isEntityChanged: true });
      }
    } else if (selection.isSingleSelectEntity) {
      this.entityService.setSingleSelectedEntity(this.selectedEntities.value);
    }
  }

  onEntitySelectionCloseAdmin() {
    this.entityService.setSelectedEntities(this.selectedEntities.value);
    if (!this.selectedEntities.value.length && this.entityService.getLastSelectedEntities().length) {
      this.tempSelectedEntities = this.entityService.getLastSelectedEntities();
      this.selectedEntities.setValue(this.tempSelectedEntities);
      this.entityService.setSelectedEntities(this.selectedEntities.value);
    }
    // check if entity dropdown value is changed then only call APIs
    if (JSON.stringify(this.selectedEntities.value) !== JSON.stringify(this.entityService.getLastSelectedEntities())) {
      this.entityService.setEntitiesChanges({ isEntityChanged: true });
    }
  }

  onEntityChangeAdmin() {
    // check if selectedEntity has 'All' option then mark all other as selected
    if (this.selectedEntities.value?.findIndex((entity) => entity.id === '0') && this.selectedEntities.value.length && this.selectedEntities.value[this.selectedEntities.value.length - 1].id === '0') {
      this.selectedEntities.setValue(this.entities);
    } else if (this.selectedEntities.value?.findIndex((entity) => entity.id === '0') === -1) {
      if (this.tempSelectedEntities.findIndex((entity) => entity.id === '0') > -1) {
        this.selectedEntities.setValue([]);
      } else if (this.selectedEntities.value.length === this.entities.length - 1 && this.selectedEntities.value.findIndex((entity) => entity.id === '0') === -1) {
        const selectedEntities = this.selectedEntities.value;
        selectedEntities.unshift({ id: '0', name: 'All' });
        this.selectedEntities.setValue(selectedEntities);
      }
    }
    if (this.selectedEntities.value.findIndex((entity) => entity.id === '0') > -1 && this.selectedEntities.value.length == 1) {
      this.selectedEntities.setValue(this.entities);
    }
    if (this.selectedEntities.value.length && this.selectedEntities.value.length !== this.entities.length && this.selectedEntities.value[0].id === '0') {
      this.selectedEntities.setValue(this.selectedEntities.value.filter((entity) => entity.id !== '0'));
    }
    this.tempSelectedEntities = [...this.selectedEntities.value];
    this.entityService.setSelectedEntities(this.tempSelectedEntities);
  }

  onEntityChange(selection: any) {
    // check if selectedEntity has 'All' option then mark all other as selected
    // if (this.selectedEntities.value?.findIndex((entity) => entity.id === '0') && this.selectedEntities.value.length && this.selectedEntities.value[this.selectedEntities.value.length - 1].id === '0') {
    //   this.selectedEntities.setValue(this.entities);
    // } else
    //  if (this.selectedEntities.value?.findIndex((entity) => entity.id === '0') === -1) {
    //   if (this.tempSelecteEntities.findIndex((entity) => entity.id === '0') > -1) {
    //     this.selectedEntities.setValue([]);
    //   } else if (this.selectedEntities.value.length === this.entities.length - 1 && this.selectedEntities.value.findIndex((entity) => entity.id === '0') === -1) {
    //     const selectedEntities = this.selectedEntities.value;
    //     selectedEntities.unshift({ id: '0', name: 'All' });
    //     this.selectedEntities.setValue(selectedEntities);
    //   }
    // }
    // if (this.selectedEntities.value.findIndex((entity) => entity.id === '0') > -1 && this.selectedEntities.value.length == 1) {
    //   this.selectedEntities.setValue(this.entities);
    // }
    // if (this.selectedEntities.value.length && this.selectedEntities.value.length !== this.entities.length && this.selectedEntities.value[0].id === '0') {
    //   this.selectedEntities.setValue(this.selectedEntities.value.filter((entity) => entity.id !== '0'));
    // }

    if (selection.isMultiSelect) {
      // mark entities as selected which are in selectedEntities form control
      if (this.selectedEntities.value?.length) {
        const findNotSelectedEntity = this.selectedEntities.value?.findIndex((notSelectedEntity) => !notSelectedEntity.isSelected);
        const findSelectedEntity = this.selectedEntities.value.findIndex((selectedEntity) => selectedEntity.isSelected);
        if (findNotSelectedEntity > -1 && findSelectedEntity > -1) {
          if (this.selectedEntities.value[findNotSelectedEntity].parentId != this.selectedEntities.value[findSelectedEntity].parentId) {
            this.selectedEntities.value.splice(findNotSelectedEntity, 1);
          }
        }
      }
      this.entities.forEach((entity) => {
        const selectedEntityIndex = this.selectedEntities.value?.findIndex((selectedEntity) => selectedEntity.id == entity.id);
        if (selectedEntityIndex > -1) {
          entity.isSelected = true;
        } else {
          entity.isSelected = false;
        }
      });
      this.disableGroupWiseEntities();
      this.entities = [...this.entities];
      this.tempSelectedEntities = [...this.selectedEntities.value];
      this.entityService.setSelectedEntities(this.selectedEntities.value);
      this.entityService.setCurrentCompanySelection(this.selectedEntities.value);
      localStorage.setItem('entities', JSON.stringify(this.entities));
    } else if (selection.isSingleSelectEntity) {
      if (this.selectedEntities.value) {
        const findSelectedIndex = this.singleSelectEntities.findIndex((singleEntity) => singleEntity.id == this.selectedEntities.value['id']);
        if (findSelectedIndex > -1) {
          this.singleSelectEntities[findSelectedIndex].isSelected = true;
          this.singleSelectEntities.forEach((singleEntity, index) => {
            if (index != findSelectedIndex) {
              singleEntity.isSelected = false;
            }
          });
          this.singleSelectEntities = [...this.singleSelectEntities];
          // this.entityService.setSingleSelectedEntity(this.singleSelectEntities[findSelectedIndex]);
        }
        this.entityService.setCurrentCompanySelection(this.selectedEntities.value);
      }
    } else if (selection.isSingleSelectCompany) {
      if (this.selectedEntities.value) {
        const findSelectedIndex = this.singleSelectCompanies.findIndex((singleCompany) => singleCompany.id == this.selectedEntities.value['id']);
        if (findSelectedIndex > -1) {
          this.singleSelectCompanies[findSelectedIndex].isSelected = true;
          this.singleSelectCompanies.forEach((singleCompany, index) => {
            if (index != findSelectedIndex) {
              singleCompany.isSelected = false;
            }
          });
          this.singleSelectCompanies = [...this.singleSelectCompanies];
          this.entityService.setSingleSelectedCompany(this.singleSelectCompanies[findSelectedIndex]);
        }
        this.entityService.setCurrentCompanySelection(this.selectedEntities.value);
      }
    }
  }

  disableGroupWiseEntities() {
    const findSelectedEntity = this.entities.find((entity) => entity.isSelected);
    if (findSelectedEntity?.parentId) {
      this.entities.forEach((entity) => {
        if (entity.parentId != findSelectedEntity.parentId) {
          entity.disabled = true;
        } else {
          entity.disabled = false;
        }
      })
    } else {
      this.entities.forEach((entity) => {
        entity.disabled = false;
      });
      this.entities = [...this.entities];
    }
  }

  compareWith(item, selected) {
    return item?.id === selected?.id;
  }
  setFieldType() {
    this.peF.invoiceFieldType.setValue(this.peF.invoiceFieldType.value === this.appGlobals.PURCHASE ? this.appGlobals.EXPENSE : this.appGlobals.PURCHASE);
    this.sharedService.updateNavBarPETab(this.peF.invoiceFieldType.value);
  }
  /**
   * This method will set last selected entities in local storage
   * so if each entity is unchecked then, last selected entities will be 
   * selected by default on dropdown close
   */
  onSelectionOpen() {
    this.isTooltipStatic = !this.isTooltipStatic;
    this.entityService.setLastSelectedEntities(this.selectedEntities.value);
    this.sharedService.toggleBlurBackground(true);
  }

  onSelectionOpenAdmin() {
    this.entityService.setLastSelectedEntities(this.selectedEntities.value);
  }

  showSideBar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    if (this.isSidebarOpen) {
      const sideBarElement = document.getElementById('leftSidebarMenu');
      const overlayDiv = document.getElementsByClassName('pmd-sidebar-overlay')[0];

      if (overlayDiv) {
        overlayDiv.classList.add('pmd-sidebar-overlay-active');
      }

      if (sideBarElement) {
        document.body.classList.add('pmd-body-open');
        sideBarElement.classList.add('pmd-sidebar-open');
        this.cdRef.detectChanges();
      }
    }
    this.isSidebarOpenChange.emit(this.isSidebarOpen);
  }

  logout() {
    this.invoiceService.invoiceFilters$?.unsubscribe();

    if (this.token) {
      this.authService.logout(this.token);
    } else {
      this.authService.logout();
      this.sharedService.cancelAPICalls$.next();
    }
  }

  /**
   * Retrieves active sync codes from the server. This method sends an HTTP GET request to the server to fetch active sync codes based on the specified parameters such as status, pageSize, and page.
   * @author Darshan Malani - 6th Sep 2023, 02:00 PM
   * @param
   */
  getSyncCode() {
    this.navbarService.getSyncCode({
      status: 'Active',
      pageSize: '1',
      page: '1',
      sortOrder: 'ASC',
      sortBy: 'createdAt'
    }).subscribe((syncCodes) => {
      if (syncCodes?.length) {
        this.syncCode = syncCodes[0];
        this.sharedService.updateSyncCode(this.syncCode);
      } else {
        this.createSyncCode();
      }
    }, (error: any) => {
      // this.sharedService.errorAlert(error)
    });
  }

  /**
   * This function makes an API request to generate a new sync code, and upon success,
   * it updates the current sync code in the UI. If an error occurs during the process,
   * it displays an error alert to notify the user.
   * @author Darshan Malani - 9th Sep 2023, 07:22:00 PM
   * @returns {void}
   */
  createSyncCode() {
    this.navbarService.createSyncCode({ count: 1 }).subscribe(
      (syncCodes) => {
        if (syncCodes?.length) {
          this.syncCode = syncCodes[0];
          this.sharedService.updateSyncCode(this.syncCode);
        } else {
          this.syncCode = '';
        }
      },
      (error: any) => this.sharedService.errorAlert(error)
    );
  }

  /**
   * Copies the sync code to the clipboard and displays a success alert.
   * This function creates a temporary textarea element, sets its value to the sync code,
   * copies the content to the clipboard using the 'execCommand' method, and then removes
   * the temporary textarea. It also displays a success alert to notify the user of the
   * successful copy operation.
   * @author Darshan Malani - 9th Sep 2023, 02:00 PM
   * @returns {void}
   */
  copySyncCodeToClipboard() {
    this.sharedService.copyToClipboard(this.syncCode);
    this.sharedService.successAlert(`Sync Code copied successfully.`);
  }

  /**
   * Refreshes the sync code by deactivating the current code and generating a new one if require.
   * This function deactivates the current sync code by making an API request to set its
   * status to 'Inactive'. After successful deactivation, it triggers the generation of
   * a new sync code and updates the UI. It also handles errors by refreshing the sync code
   * in case of failure.
   * @author Darshan Malani - 9th Sep 2023, 04:00 PM
   * @param {Event} event - The event object to stop propagation.
   * @returns {void}
   */
  refreshSyncCode(event: Event) {
    event.stopPropagation();

    if (this.loggedinUser.isSecondaryOwner) {
      return;
    }

    this.navbarService.deactivateSyncCode({
      ids: [this.syncCode],
      status: 'Inactive'
    }).subscribe((syncCodes) => {
      this.getSyncCode();
    }, (error: any) => this.getSyncCode());
  }

  toggleDropdown() {
    const currentURL = this.router.url;

    if (currentURL.startsWith('/invoice/')) { // Check if the current URL is an invoice page
      // Check if the user has unsaved changes in the invoice
      const payload = this.sharedService.getInvoiceFromLocal(this.sharedService.currentInvoiceDetail.companyId, this.sharedService.currentInvoiceDetail.invoiceId);

      if (payload) {
        this.invoiceService.autoSaveReview(payload).subscribe((response) => {
          this.sharedService.removeInvoiceDraft(this.sharedService.currentInvoiceDetail.companyId, this.sharedService.currentInvoiceDetail.invoiceId);
        }, (error: any) => {
          console.log(error);
          this.sharedService.errorAlert(error);
        });
      }
    }

  }

  openSideBar() {
    this.sharedService.updateCurrentSideBarStatus(true);
  }

  redirectToUploadInvoice() {
    this.router.navigate(['invoice/upload']);
  }

  canShowMultiSelectCompanyDropdown() {
    const canShowMultiSelectModules = this.multiSelectModules.some(path => this.router.url.startsWith(path)) && !this.router.url.includes('/invoice/upload') &&
      !this.router.url.includes('/payments/invoices/') &&
      !this.authService.user.isAdmin && !this.authService.user.isLeadAdmin;
    return canShowMultiSelectModules;
  }

  canShowSingleEntityDropdown() {
    const canShowSingleSelectModules = this.singleSelectModules.some(path => this.router.url.startsWith(path)) && this.singleSelectEntities.length && !this.authService.user.isAdmin;
    return canShowSingleSelectModules;
  }

  canShowSingleCompanyDropdown() {
    const canShowSingleSelectCompanyModules = this.singleSelectCompanyModules.some(path => this.router.url.startsWith(path)) && !this.authService.user.isAdmin;
    return canShowSingleSelectCompanyModules;
  }

  /**
   * This method will check if the previous URL had a multi-select dropdown or not
   * @returns boolean
   */
  wasMultiSelectCompanyDropdown() {
    const previousURL = this.previousURL;
    if (previousURL) {
      const wasMultiSelectModule = this.multiSelectModules.some(path => previousURL?.startsWith(path)) && !previousURL.includes('/invoice/upload') && !this.authService.user.isAdmin && !this.authService.user.isLeadAdmin;
      return wasMultiSelectModule;
    } else {
      return false;
    }
  }

  /**
   * This method will check if the previous URL had single company dropdown or not
   * @returns boolean
   */
  wasSingleSelectCompanyDropdown() {
    const previousURL = this.previousURL;
    if (previousURL) {
      const wasFromSingleSelectCompanyModules = this.singleSelectCompanyModules.some(path => previousURL.startsWith(path)) && !this.authService.user.isAdmin;
      return wasFromSingleSelectCompanyModules;
    } else {
      return false;
    }
  }

  /**
   * This method will check if previous URL had single entity dropdown or not
   * @returns boolean
   */
  wasSingleEntityDropdown() {
    const previousURL = this.previousURL;
    if (previousURL) {
      const wasFromSingleEntityModules = this.singleSelectModules.some(path => previousURL.startsWith(path)) && this.singleSelectEntities.length && !this.authService.user.isAdmin;
      return wasFromSingleEntityModules;
    } else {
      return false;
    }
  }

  wasCompanyManagementPage() {
    const previousURL = this.previousURL;
    if (previousURL && JSON.parse(localStorage.getItem('wasCompanyStatusChanged'))) {
      localStorage.removeItem('wasCompanyStatusChanged');
      return previousURL.startsWith('/company-management');
    } else {
      return false;
    }
  }

  wasEntityManagementPage() {
    const previousURL = this.previousURL;
    if (previousURL && JSON.parse(localStorage.getItem('wasEntityStatusChanged'))) {
      localStorage.removeItem('wasEntityStatusChanged');
      return previousURL.startsWith('/entity');
    } else {
      return false;
    }
  }

  isAllSelected(items: any[]): boolean {
    if (!this.entities || this.entities.length === 0) return false;
    return items.length === this.entities.length;
  }

  checkIfPrimaryCompanyChanged() {
    const isPrimaryCompanyChanged = JSON.parse(localStorage.getItem('isPrimaryCompanyChanged'));
    if (isPrimaryCompanyChanged) {
      localStorage.removeItem('isPrimaryCompanyChanged');
    }
    return isPrimaryCompanyChanged;
  }

  checkIfEntityAddedOrUpdated() {
    const isEntityAddedOrUpdated = JSON.parse(localStorage.getItem('wasEntityAddedOrUpdated'));
    return isEntityAddedOrUpdated;
  }

  getUpdatedCountForCompanies() {
    this.isCompanyDropdownOpen = true;
    this.entityService.fetchCompanies();
  }

  onCompanyDropdownClose() {
    this.isCompanyDropdownOpen = false;
  }

  /**
   * This method will check if all entities of a given group are checked
   */
  isGroupChecked(group: any): boolean {
    const findGroupEntities = this.entities.filter((entity: any) => entity.group === group);
    const selectedGroupEntities = findGroupEntities?.filter((entity: any) => entity.isSelected).length;
    return selectedGroupEntities == findGroupEntities?.length;
  }

  /**
   * This method will check if some entities of a given group are checked
   */
  isGroupIndeterminate(group: any): boolean {
    const findGroupEntities = this.entities.filter((entity: any) => entity.group === group);
    const selectedGroupEntities = findGroupEntities?.filter((entity: any) => entity.isSelected).length;
    return selectedGroupEntities > 0 && selectedGroupEntities < findGroupEntities?.length;
  }

  /**
   * This method will be called when the selection of a group changes
   * @param event 
   * @param group 
   */
  onGroupSelectionChange(event: any, group: any) {
    const entitiesToSet: any = [];
    if (event.checked) {
      this.entities.forEach((entity: any) => {
        if (entity.group === group) {
          entity.isSelected = true;
          entitiesToSet.push(entity);
        }
      });
      this.selectedEntities.setValue(entitiesToSet);
    } else {
      this.selectedEntities.setValue([]);
    }
  }

  ngOnDestroy(): void {
    this.selectedCompanySubscription?.unsubscribe();
    this.selectedCompanyListSubscription?.unsubscribe();
    this.selectedEntities.reset();
  };
}